import * as yup from 'yup';
import { mapYupObjectError, objectMap } from 'utils/helpers';
import { requiredOnly, validateAmount, validatePhone } from 'utils/validation';
import { IFormValues } from './ManualEntry.model';

const schema = yup.object().shape({
  sourceAccount: requiredOnly('Source Account'),
  transferData: yup.array().of(
    yup.object().shape({
      netWork: requiredOnly('Network'),
      beneficiaryWalletNumber: validatePhone('Beneficiary Wallet Number'),
      walletName: requiredOnly('Wallet Name'),
      description: requiredOnly('Description'),
      amount: validateAmount(),
      beneficiaryName: requiredOnly('Beneficiary Name'),
    }),
  ),
});
const validate = (values: IFormValues) => {
  try {
    schema.validateSync(values, { abortEarly: false });
  } catch (e) {
    const valErrs = mapYupObjectError<IFormValues>(e);
    return objectMap(valErrs, (v) => v[0]);
  }
  return undefined;
};

export default validate;
